import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';

function DocumentIndexTermsHitComponent({ keywords, closeClick, trackingAttrs }) {
  const indexTermsHit = DocumentHitsFormat.checkAndFormatIndexTermsHit(keywords);

  return indexTermsHit ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className="result-detail-panel result-detail-index-terms-hit document-hit e2e-document-action-index-terms-hit"
      onClick={closeClick}
      role="button"
      tabIndex="0"
      {...trackingAttrs}>
      <div className="result-detail-panel-wrapper">
        <h4>Index Terms hit:</h4>
        <InnerHTML tag="div" className="result-detail-block typography-small" html={indexTermsHit} />
        <svg className="els-btn-icon svg-icon els-btn-icon-sm">
          <use xlinkHref="#icon-chevron-down" />
        </svg>
      </div>
    </div>
  ) : null;
}

DocumentIndexTermsHitComponent.propTypes = {
  keywords: PropTypes.array.isRequired,
  closeClick: PropTypes.func.isRequired,
  // for analytics
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentIndexTermsHitComponent;
